<ng-template vdrDialogTitle>{{
  "requestPurchase.createPurchaseRequest" | translate
}}</ng-template>
<p>{{ message | translate }}</p>

<form class="form" [formGroup]="detailForm">
  <!-- <h3 style="margin-bottom: 1rem">
    {{ detailForm.value.name }}
  </h3> -->

  <vdr-form-field [label]="'common.productName' | translate">
    <div style="width: 100%">
      <product-selector
        (productSelected)="onSelectProduct($event)"
      ></product-selector>
    </div>
  </vdr-form-field>

  <div class="form-grid" style="margin-top: 1rem">
    <vdr-form-field [label]="'requestPurchase.note' | translate" for="note">
      <input type="text" id="note" formControlName="note" />
    </vdr-form-field>

    <vdr-form-field [label]="'requestPurchase.supplier' | translate" for="note">
      <ng-select
        [items]="suppliers$ | async"
        appendTo="body"
        bindLabel="name"
        [addTag]="false"
        [multiple]="false"
        [hideSelected]="true"
        [trackByFn]="trackByFn"
        [minTermLength]="2"
        [typeahead]="input$"
        [loading]="isLoading"
        formControlName="supplier"
      >
        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          <span class="item-row">
            <clr-icon shape="bundle" class="is-solid"></clr-icon>
            <span class="mx-1">{{ item.name }}</span>
          </span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <span class="item-row">
            <clr-icon shape="bundle" class="is-solid"></clr-icon
            ><span class="mx-1"> {{ item.name }}</span>
          </span>
        </ng-template>
      </ng-select>
    </vdr-form-field>

    <vdr-form-field [label]="'requestPurchase.retailer' | translate" for="note">
      <ng-select
        [items]="retailers$ | async"
        appendTo="body"
        bindLabel="name"
        [addTag]="false"
        [multiple]="false"
        [hideSelected]="true"
        [trackByFn]="trackByFn"
        [minTermLength]="2"
        [typeahead]="inputRetailer$"
        [loading]="isLoadingRetailer"
        formControlName="retailer"
      >
        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          <span class="item-row">
            <clr-icon shape="bundle" class="is-solid"></clr-icon>
            <span class="mx-1">{{ item.name }}</span>
          </span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <span class="item-row">
            <clr-icon shape="bundle" class="is-solid"></clr-icon
            ><span class="mx-1"> {{ item.name }}</span>
          </span>
        </ng-template>
      </ng-select>
    </vdr-form-field>
  </div>

  <div
    *ngIf="detailForm.value.productId"
    style="border-top: 1px solid #ccc; padding-top: 0.7rem; margin-top: 1rem"
  >
    <h4 style="margin-top: 0px; margin-bottom: 1rem">
      {{ "catalog.product-variants" | translate }}
    </h4>

    <vdr-form-field [label]="'requestPurchase.add-variant-request' | translate">
      <div style="width: 100%">
        <product-variant-selector
          (productSelected)="onSelectProductVariant($event)"
          [productId]="detailForm.value.productId"
        ></product-variant-selector>
      </div>
    </vdr-form-field>
  </div>

  <ng-container formArrayName="requests">
    <div
      class="mt-2"
      *ngFor="
        let request of detailForm.controls.requests.controls;
        let i = index
      "
    >
      <div style="display: flex; width: 100%; align-items: end">
        <div style="width: 100%; display: flex">
          <vdr-form-field
            [label]="'requestPurchase.productVariantName' | translate"
            style="width: 30%; margin-right: 1rem"
          >
            <input
              type="text"
              readonly
              id="sku"
              [formControl]="request.get('productVariant')"
            />
          </vdr-form-field>
          <vdr-form-field
            [label]="'catalog.sku' | translate"
            style="width: 30%; margin-right: 1rem"
          >
            <input
              type="text"
              readonly
              id="sku"
              [formControl]="request.get('sku')"
            />
          </vdr-form-field>
          <vdr-form-field
            [label]="'requestPurchase.expectedDate' | translate"
            for="date"
            style="width: 30%; margin-right: 1rem"
          >
            <input
              type="date"
              [min]="today"
              id="expectedDate"
              [formControl]="request.get('expectedDate')"
            />
          </vdr-form-field>
        </div>

        <div style="margin-left: 6px; margin-bottom: 6px">
          <clr-icon
            shape="trash"
            class="is-error ml-1"
            size="24"
            (click)="removeProductVariant(request.get('id').value)"
            [style.cursor]="'pointer'"
          ></clr-icon>
        </div>
      </div>

      <div
        class="flex flex-row mt-1"
        style="justify-content: space-between; width: 100%; align-items: end"
      >
        <vdr-form-field
          [label]="'requestPurchase.orderQuantity' | translate"
          style="width: 27%"
        >
          <input
            type="number"
            readonly
            id="orderQuantity"
            [formControl]="request.get('orderQuantity')"
          />
        </vdr-form-field>
        <vdr-form-field
          [label]="'requestPurchase.currentStock' | translate"
          style="width: 27%"
        >
          <input
            type="number"
            readonly
            id="stockOnHand"
            [formControl]="request.get('stockOnHand')"
          />
        </vdr-form-field>

        <vdr-form-field
          [label]="'requestPurchase.quantityNeeded' | translate"
          style="width: 27%"
          *ngIf="!request.get(['notSpecify']).value"
        >
          <input
            type="number"
            id="quantity"
            [formControl]="request.get('quantity')"
          />
        </vdr-form-field>

        <div
          style="width: 27%; margin-bottom: 10px"
          *ngIf="request.get(['notSpecify']).value"
        >
          {{ "requestPurchase.not-specify-stock" | translate }}
        </div>

        <div
          style="display: flex; flex-direction: column; align-items: center"
          *ngIf="detailForm.value.isGift"
        >
          <label for="notSpecify">
            {{ "requestPurchase.not-specify-stock" | translate }}</label
          >
          <clr-toggle-wrapper>
            <input
              id="notSpecify"
              type="checkbox"
              clrToggle
              name="enabled"
              [formControl]="request.get(['notSpecify'])"
            />
          </clr-toggle-wrapper>
        </div>
      </div>
      <div
        *ngIf="detailForm.controls.requests.controls.length > 1"
        class="mx-auto"
        style="
          width: 80%;
          border-bottom: 0.5px dashed #ccc;
          padding-bottom: 0.7rem;
        "
      ></div>
    </div>
  </ng-container>

  <div
    *ngIf="detailForm.value.productId && !detailForm.value.isGift"
    style="border-top: 1px solid #ccc; padding-top: 0.7rem; margin-top: 1rem"
  >
    <h4 style="margin-top: 0px">
      {{ "freeGift.freeGifts" | translate }}
    </h4>

    <div
      *ngIf="detailForm.controls.gifts.controls.length > 1"
      class="mx-auto"
    ></div>

    <div
      style="margin-top: 1rem"
      *ngFor="let request of detailForm.controls.gifts.controls; let i = index"
    >
      <div style="display: flex; width: 100%; align-items: end">
        <div style="width: 100%; display: flex">
          <vdr-form-field
            [label]="'requestPurchase.productVariantName' | translate"
            style="width: 30%; margin-right: 1rem"
          >
            <div style="width: 100%">
              <product-variant-selector
                (productSelected)="addGiftRequestForm($event, request)"
                [freeGifts]="true"
              ></product-variant-selector>
            </div>
          </vdr-form-field>
          <vdr-form-field
            [label]="'catalog.sku' | translate"
            style="width: 30%; margin-right: 1rem"
          >
            <input
              type="text"
              readonly
              id="sku"
              [formControl]="request.get('sku')"
            />
          </vdr-form-field>
          <vdr-form-field
            [label]="'requestPurchase.expectedDate' | translate"
            for="date"
            style="width: 30%; margin-right: 1rem"
          >
            <input
              type="date"
              [min]="today"
              id="expectedDate"
              [formControl]="request.get('expectedDate')"
            />
          </vdr-form-field>
        </div>

        <div style="margin-left: 6px; margin-bottom: 6px">
          <clr-icon
            shape="trash"
            class="is-error ml-1"
            size="24"
            (click)="removeGift(i)"
            [style.cursor]="'pointer'"
          ></clr-icon>
        </div>
      </div>

      <div
        class="flex flex-row mt-1"
        style="justify-content: space-between; width: 100%; align-items: end"
      >
        <vdr-form-field
          [label]="'requestPurchase.orderQuantity' | translate"
          style="width: 27%"
        >
          <input
            type="number"
            readonly
            id="orderQuantity"
            [formControl]="request.get('orderQuantity')"
          />
        </vdr-form-field>
        <vdr-form-field
          [label]="'requestPurchase.currentStock' | translate"
          style="width: 27%"
        >
          <input
            type="number"
            readonly
            id="stockOnHand"
            [formControl]="request.get('stockOnHand')"
          />
        </vdr-form-field>
        <vdr-form-field
          [label]="'requestPurchase.quantityNeeded' | translate"
          style="width: 27%"
          *ngIf="!request.get(['notSpecify']).value"
        >
          <input
            type="number"
            id="quantity"
            [formControl]="request.get('quantity')"
          />
        </vdr-form-field>

        <div
          style="width: 27%; margin-bottom: 10px"
          *ngIf="request.get(['notSpecify']).value"
        >
          {{ "requestPurchase.not-specify-stock" | translate }}
        </div>

        <div style="display: flex; flex-direction: column; align-items: center">
          <label for="notSpecify">
            {{ "requestPurchase.not-specify-stock" | translate }}</label
          >
          <clr-toggle-wrapper>
            <input
              type="checkbox"
              clrToggle
              name="enabled"
              [formControl]="request.get(['notSpecify'])"
            />
          </clr-toggle-wrapper>
        </div>
      </div>
      <div
        *ngIf="detailForm.controls.gifts.controls.length > 1"
        class="mx-auto"
        style="
          width: 80%;
          border-bottom: 0.5px dashed #ccc;
          padding-bottom: 0.7rem;
        "
      ></div>
    </div>

    <button
      class="btn btn-primary"
      (click)="addGift()"
      style="width: 100%; justify-content: center; margin-top: 1rem"
    >
      <clr-icon shape="plus"></clr-icon>

      {{ "common.add-gift" | translate }}
    </button>
  </div>
</form>

<p style="color: red">{{ error }}</p>

<ng-template vdrDialogButtons>
  <button *ngIf="cancellable" (click)="cancel()" class="btn btn-secondary">
    {{ "common.cancel" | translate }}
  </button>

  <button
    [disabled]="
      detailForm.pristine ||
      detailForm.invalid ||
      detailForm.value.requests.length <= 0
    "
    class="btn btn-primary"
    (click)="select()"
  >
    {{ "requestPurchase.request" | translate }}
  </button>
</ng-template>
